import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "semantic-ui-react";
import { declareVisitGender } from "../../../services/statsApi";
import { getOrCreateSessionId } from "../../../services/sessionId";
import { getGenderPromptStrings } from "../../../datas/genderPromptStrings";
import "./genderprompt.css";

const STORAGE_KEY = "1755-gender:dismissed";

const GenderPrompt = () => {
  const [visible, setVisible] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (typeof localStorage === "undefined") return;
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const submit = async (gender) => {
    setSending(true);
    const sessionId = getOrCreateSessionId();
    if (sessionId) {
      try {
        await declareVisitGender(sessionId, gender);
      } catch (_) {
        // best-effort
      }
    }
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  const t = getGenderPromptStrings(
    typeof navigator !== "undefined" ? navigator.language : "fr",
  );

  return createPortal(
    <div
      className="gender-prompt"
      role="dialog"
      aria-label={t.title}
      dir={t.rtl ? "rtl" : "ltr"}
    >
      <div className="gender-prompt-text">{t.title}</div>
      <div className="gender-prompt-actions">
        <Button
          circular
          color="pink"
          disabled={sending}
          onClick={() => submit("female")}
        >
          ♀ {t.female}
        </Button>
        <Button
          circular
          color="blue"
          disabled={sending}
          onClick={() => submit("male")}
        >
          ♂ {t.male}
        </Button>
        <Button
          circular
          color="grey"
          disabled={sending}
          onClick={() => submit("other")}
        >
          ⚧ {t.other}
        </Button>
      </div>
      <button
        className="gender-prompt-decline"
        disabled={sending}
        onClick={() => submit("declined")}
      >
        {t.decline}
      </button>
    </div>,
    document.body,
  );
};

export default GenderPrompt;
